export const extendedPages = [
	'/importacao-pedido/finalizar-pedido',
	'/importacao-pedido/confirmacao-de-compra',
	'/importacao-pedido/resultado',
];
